import axios from '@/axios';
import Vue from 'vue';

const FALLBACK_CURRENCY = {
	code: 'EUR',
	symbol: '€',
	value: 1,
};

const state = Vue.observable({
	currencies: [],
	isLoaded: false,
	isLoading: false,
});

const listeners = [];

const getCurrencyCode = () => {
	return localStorage.getItem('currency_code') || FALLBACK_CURRENCY.code;
};

const getCurrencySymbol = () => {
	return localStorage.getItem('currency_symbol') || FALLBACK_CURRENCY.symbol;
};

const notifyListeners = () => {
	listeners.forEach((listener) => listener());
};

const setCurrency = (currency) => {
	if (!currency || !currency.code) {
		return;
	}

	localStorage.setItem('currency_code', currency.code);
	localStorage.setItem('currency_symbol', currency.symbol || currency.code);

	notifyListeners();
};

const fetchCurrencies = async () => {
	if (state.isLoading) {
		return state.currencies;
	}

	state.isLoading = true;

	try {
		const response = await axios.get('currencies', {
			noParams: true,
		});

		const data = response.data;

		if (data.status === 'OK' && Array.isArray(data.payload)) {
			state.currencies = data.payload;
			state.isLoaded = true;

			const currentCode = getCurrencyCode();

			const currentCurrency = state.currencies.find(
				(currency) => currency.code === currentCode,
			);

			if (currentCurrency) {
				setCurrency(currentCurrency);
			} else if (state.currencies.length) {
				setCurrency(state.currencies[0]);
			}
		}

		return state.currencies;
	} catch (error) {
		console.error('Failed to load currencies:', error);
		return [];
	} finally {
		state.isLoading = false;
	}
};

const onCurrencyChange = (callback) => {
	if (typeof callback !== 'function') {
		return () => {};
	}

	listeners.push(callback);

	return () => {
		const index = listeners.indexOf(callback);

		if (index !== -1) {
			listeners.splice(index, 1);
		}
	};
};

export default function useCurrency() {
	return {
		state,
		getCurrencyCode,
		getCurrencySymbol,
		setCurrency,
		fetchCurrencies,
		onCurrencyChange,
	};
}
